export default {
  "nl": {
    "profile": {
      "actions": {
        "changeEmail": "E-mailadres wijzigen",
        "changeEmailAddress": "Verander e-mailadres",
        "delete": "Verwijderen",
        "save": "Opslaan"
      },
      "attributes": {
        "decimal_separator": "Decimale valutanotatie",
        "email_address": "E-mail",
        "email_address_new": "Nieuw e-mailadres",
        "email_address_old": "Oud e-mailadres"
      },
      "labels": {
        "allowAccess": "Geef Ziggu toegang tot jouw account",
        "allowImpersonation": "Geef Ziggu toegang",
        "allowImpersonationSubtext": "Mogelijk hebbben we tijdelijk toegang nodig tot uw account om een probleem te onderzoeken dat u gerapporteerd heeft. Onze toegang vervalt automatisch na 7 dagen.",
        "allowRecording": "Sessie opname toestaan",
        "allowRecordingSubtext": "Jouw sessie binnen Ziggu opnemen, kan ons helpen om de oorzaak op te sporen van een probleem dat je ondervindt. De opname stopt automatisch na 60 minuten of wanneer je dit zelf uitschakelt.",
        "and_x_other": "en 1 andere | en {other_count} anderen",
        "bulk_invite_help": "We nodigen de geselecteerde contacten uit voor het platform. Dit kan enkele minuten duren.",
        "changeEmailAddress": "E-mailadres veranderen voor {profile_name}",
        "checkYourInbox": "We hebben een e-mail verzonden naar {email_address} ter confirmatie",
        "confirmEmailUpdate": "De e-mail bevat een link om het updateproces te voltooien. Neem contact met ons op als je problemen ondervindt.",
        "confirmPasswordReset": "E-mail verzonden met een link om je wachtwoord te wijzigen, gelieve je inbox te controleren. Contacteer ons aub als je problemen ondervindt.",
        "currency": {
          "comma": "Komma: 200.450,99",
          "point": "Punt: 200,450.99"
        },
        "delete_info": "Ben je zeker dat je deze gebruiker wilt verwijderen? Deze actie zal alle gevoelige persoonlijke data verwijderen en zal de gebruiker niet meer toelaten om in te loggen en emails te ontvangen",
        "delete_user": "Verwijder {user_name}",
        "emailAddressNewConfirm": "Bevestig nieuw e-mailadres",
        "emailNotificationsInterval": "E-mailfrequentie voor nieuwe meldingen",
        "emailNotificationsIntervalSubtext": "Hier kan je instellen hoe vaak je wilt dat het platform controleert of er nieuwe meldingen zijn en jou hierover een e-mail stuurt.",
        "explainerSendEmail": "Een nieuwe uitnodigingse-mail zal verzonden worden naar {name}",
        "explainerUpdateEmailActive": "{name} is al actief op het platform. Een bevestigingse-mail met de wijziging zal naar het nieuwe e-mailadres worden verzonden.",
        "explainerUpdateEmailInvited": "{name} is al uitgenodigd. Er wordt een nieuwe uitnodiging verzonden naar het nieuwe e-mailadres. Eerdere uitnodigingen zullen niet meer functioneel zijn.",
        "impersonateProfile": "Impersonatie {profile_name}",
        "maintainerCannotImpersonatePartner": "Enkel teamleden met de rol 'Eigenaar' kunen partners impersoneren.",
        "maintainerCannotUpdateEmailAddress": "Enkel teamleden met de rol 'Eigenaar' kunnen het e-mailadres van de klant wijzigen.",
        "multipleProfiles": "Deze gebruiker heeft meerdere Ziggu-profielen. Alleen de gebruiker kan het e-mailadres wijzigen.",
        "noEmailAddressAdded": "Geen e-mailadres toegevoegd",
        "public_api_access": "Openbaar API-toegangstoken",
        "redirectAutomatically": "Je wordt automatisch terugverwezen binnen {seconds} seconden",
        "requestPasswordReset": "Wachtwoord wijzigen",
        "updateEmailFailed": "Je e-mailadres kan niet worden bijgewerkt. Probeer het opnieuw of neem contact met ons op.",
        "updateEmailSuccessful": "Je e-mailadres is succesvol bijgewerkt",
        "writeProfileNameReject": "Schrijf <i><b>{profile_name}</b></i> neer om door te gaan"
      },
      "notifications": {
        "avatarChangedSuccessfully": "De avatar is bijgewerkt. Het kan een uur duren voordat de wijzigingen zichtbaar zijn."
      },
      "toasts": {
        "bulk_invite": "We zijn begonnen met het uitnodigen van de geselecteerde contacten voor het platform",
        "emailResendSuccessfully": "E-mail met succes verzonden"
      },
      "validation": {
        "emailAddressBounce": {
          "hard_bounce": "Het e-mailadres bestaat niet (meer), gelieve het e-mailadres te veranderen.",
          "isp_block": "ISP blokkering: een blokkering betekent meestal dat ons IP adres of server is geweigerd door de ontvangende email server.",
          "soft_bounce": "De persoon is out of office, of de mailbox is vol en aanvaardt geen e-mails meer.",
          "spam_complaint": "De persoon klikte op \"Markeren als spam\" in zijn email client, dit e-mailadres is hierdoor gedeactiveerd. Indien de ontvanger u gecontacteerd heeft om opnieuw e-mails te ontvangen, dan mag u ons contacteren.",
          "spam_notification": "E-mails worden geweigerd door de emailserver. Dit kan veroorzaakt worden door een strikt veiligheidsbeleid op de ontvangende email server, of een slechte keuze van woorden in de e-mail, waardoor de e-mail gemarkeerd werd als spam door automatische spam filters."
        },
        "emailAddressBounced": "E-mailadres foutmelding",
        "emailDoesntMatch": "E-mailadres komt niet overeen",
        "emailTaken": "E-mailadres is al in gebruik",
        "mustBeEmailAddress": "Geldig e-mailadres vereist",
        "requireEmailAddress": "E-mail vereist",
        "tooManyRequests": "Slechts één wijziging van het e-mailadres is toegestaan elke 5 minuten. Probeer het later opnieuw."
      }
    }
  }
}